<section>
  <h3>Classe JAVA</h3>
  <form>
    <label for="java-class"> Copier/coller la classe JAVA ci-dessous</label>
    <textarea id="java-class" name="javaText" [(ngModel)]="javaText" (input)="updateCode()"> </textarea>
  </form>
</section>
